import React, { useEffect } from 'react';
import './Pricing.css';
import PricingPlan from './PricingPlan';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addPurchasePlan } from '../DataStore/Slices/purchaseSlice';
import CheckUserProvider from '../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';

function Pricing() {
    const history = useHistory();
    const dispatch = useDispatch();
    const { userData } = CheckUserProvider();

    const handleBuyNow = async (name, amount, isFreeTrail = false) => {
        dispatch(addPurchasePlan({
            planName: name,
            planPrice: amount,
            freeTrail: isFreeTrail,
        }));

        history.push('/activity/Register');
    }

    useEffect(() => {
        history.push('/pricing');
    }, []);

    useEffect(() => {
        if (userData) {
            if (userData.userRole === 'Retailer') {
                history.push('/activity/dashboard');
            }
        }
    }, [userData]);

    return (
        <>
            <div className="container-fluid mb-5">
                <Helmet>
                    <meta name="description" content="Choose your plan to use these website paid features..." />
                    <title>Pricing | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="row">
                    <div className="col-10 mx-auto">
                        <div className="row pricing">
                            <div className="col-md-12">
                                <div className="pricing__header">
                                    <h2 className="pricing__title"><span>Pricing</span></h2>
                                    <div className="pricing__headerDescription">
                                        Select your packet and Order online now to get access to the best ICT product platform.<br></br>
                                        <p style={{ color: 'orange', lineHeight: '20px' }}>
                                            Completely free for government organizations.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mt-2">
                                <PricingPlan handleBuyNow={handleBuyNow} isFreeTrailButtonVisible={false} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Pricing
